import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button
} from '@mui/material';
import {
  Description as DocumentsIcon,
  Photo as PhotosIcon,
  Event as EventsIcon,
  People as TreeIcon,
  Chat as DiscussionsIcon,
  LocalHospital as HealthIcon,
  Recommend as RecommendIcon,
  Restaurant as RecipesIcon,
  EmojiEvents as GoalsIcon,
  Warning as EmergencyIcon,
  EmojiEmotions as FunIcon,
  ContactPhone as ContactsIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';

const QuickLinkButton = ({ to, icon: Icon, label, color }) => (
  <Grid item xs={4} sm={3} md={2}>
    <Button
      component={Link}
      to={to}
      variant="outlined"
      fullWidth
      sx={{
        py: 1,
        px: 0.5,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        borderRadius: 1.5,
        borderColor: 'divider',
        '&:hover': {
          borderColor: color || 'primary.main',
          bgcolor: 'action.hover'
        }
      }}
    >
      <Icon sx={{ fontSize: 22, color: color || 'primary.main' }} />
      <Typography variant="caption" sx={{ fontWeight: 500, fontSize: '0.65rem', lineHeight: 1.2, textAlign: 'center' }}>
        {label}
      </Typography>
    </Button>
  </Grid>
);

const QuickLinks = () => {
  return (
    <Card>
      <CardContent sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
        <Typography variant="subtitle2" gutterBottom sx={{ mb: 1 }}>
          Quick Access
        </Typography>
        <Grid container spacing={1}>
          <QuickLinkButton
            to="/documents?tab=familyDocuments"
            icon={DocumentsIcon}
            label="Family Documents"
            color="primary.main"
          />
          <QuickLinkButton
            to="/photos?tab=family"
            icon={PhotosIcon}
            label="Family Photos"
            color="success.main"
          />
          <QuickLinkButton
            to="/events"
            icon={EventsIcon}
            label="Events"
            color="secondary.main"
          />
          <QuickLinkButton
            to="/family-tree"
            icon={TreeIcon}
            label="Family Tree"
            color="info.main"
          />
          <QuickLinkButton
            to="/discussions"
            icon={DiscussionsIcon}
            label="Discussions"
            color="warning.main"
          />
          <QuickLinkButton
            to="/health-updates"
            icon={HealthIcon}
            label="Health"
            color="error.main"
          />
          <QuickLinkButton
            to="/recommendations"
            icon={RecommendIcon}
            label="Recommendations"
            color="success.main"
          />
          <QuickLinkButton
            to="/recipes"
            icon={RecipesIcon}
            label="Recipes"
            color="warning.main"
          />
          <QuickLinkButton
            to="/goals"
            icon={GoalsIcon}
            label="Goals"
            color="warning.main"
          />
          <QuickLinkButton
            to="/emergency-info"
            icon={EmergencyIcon}
            label="Emergency"
            color="error.main"
          />
          <QuickLinkButton
            to="/fun-social"
            icon={FunIcon}
            label="Fun & Social"
            color="secondary.main"
          />
          <QuickLinkButton
            to="/contacts"
            icon={ContactsIcon}
            label="Contacts"
            color="info.main"
          />
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuickLinks;
